import { useRef } from 'react';
import { useScaleCanvas } from '../../use-scale-canvas';
import arraw from '../../images/arrow.svg';
import avatar from '../../images/Image.png';
import spark from '../../images/sparkle.svg';

const CANVAS_W = 640;
const CANVAS_H = 660;

type StatPillProps = {
  top: number;
  left: number;
  width: number;
  children: React.ReactNode;
};

const StatPill = ({ top, left, width, children }: StatPillProps) => (
  <div
    className='absolute flex items-start gap-1 rounded-[12px] bg-accent-500 px-4 py-2 text-[16px] shadow-xs'
    style={{ top, left, width, height: 64 }}
  >
    <div className='flex-1'>{children}</div>
  </div>
);

export const ResumeShowcase = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const { wrapperStyle, canvasStyle } = useScaleCanvas(sectionRef, CANVAS_W, CANVAS_H);

  return (
    <section
      ref={sectionRef}
      className='relative flex h-full w-full items-center justify-center overflow-hidden bg-warning-50'
    >
      <div style={wrapperStyle}>
      <div style={canvasStyle}>
        <img
          src={arraw}
          alt=''
          className='absolute'
          style={{ top: -21, left: 530, width: 166, height: 165 }}
        />

        <img
          src={avatar}
          alt=''
          className='absolute rounded-tr-[64px] rounded-bl-[64px] object-cover'
          style={{ top: 172, left: 86, width: 461, height: 404 }}
        />

        <img
          src={spark}
          alt=''
          className='absolute'
          style={{ top: 410, left: -82, width: 227, height: 227 }}
        />

        <h1
          className='absolute m-0 text-display-md font-bold text-gray-700'
          style={{ top: 41, left: 28, width: 552 }}
        >
          Grow as a leader while creating lasting impact.
        </h1>

        <StatPill top={149} left={388} width={215}>
          <span className='font-bold text-gray-700'>96%</span>{' '}
          <span className='font-medium text-gray-700'>of professionals grew as leaders</span>
        </StatPill>

        <StatPill top={536} left={34} width={265}>
          <span className='font-bold text-gray-700'>82%</span>{' '}
          <span className='font-medium text-gray-700'>
            of organizations boosted skills and capacity
          </span>
        </StatPill>
      </div>
      </div>
    </section>
  );
};
